var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 15,
    height: 15,
    transform: "translate(1294 340)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16",
    "data-name": "Mask Group 16",
    transform: "translate(-1294 -340)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1293.114 339.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M12.722,15.938H4.153a1.373,1.373,0,0,1-1.341-1.406V5.264H3.75v9.267a.436.436,0,0,0,.4.469h8.569a.436.436,0,0,0,.4-.469V5.264h.938v9.267A1.373,1.373,0,0,1,12.722,15.938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M14.428,4.219H2.344a.469.469,0,0,1,0-.937H14.428a.469.469,0,1,1,0,.938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M9.844,6.094h.938v7.031H9.844Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M6.094,6.094h.938v7.031H6.094Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M10.781,2.747H9.891V1.875H6.984v.872H6.094V1.875A.937.937,0,0,1,6.984.938H9.891a.937.937,0,0,1,.891.938Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashwhite);
export default __webpack_public_path__ + "static/media/trashwhite.4c6a72020e8071bf4cc8d3888040dee5.svg";
export { ForwardRef as ReactComponent };